import { ApplicationConfig } from "resource-planner-model";

export const FETCH_APPLICATION_CONFIG = "application-config/fetch";
export const LOAD_APPLICATION_CONFIG = "application-config/load";
export const PERSIST_APPLICATION_CONFIG = "application-config/persist";

export interface ApplicationConfigState {
  item: ApplicationConfig;
}

export interface FetchApplicationConfigAction {
  type: typeof FETCH_APPLICATION_CONFIG;
}

export interface LoadApplicationConfigAction {
  type: typeof LOAD_APPLICATION_CONFIG;
  item: ApplicationConfig;
}

export interface PersistApplicationConfigAction {
  type: typeof PERSIST_APPLICATION_CONFIG;
  item: ApplicationConfig;
}

export type ApplicationConfigAction =
  | FetchApplicationConfigAction
  | LoadApplicationConfigAction
  | PersistApplicationConfigAction;
